import createSagaMiddleware from "redux-saga";
import { combineReducers, configureStore } from "@reduxjs/toolkit";
import rootSaga from "./rootSaga";
import thunk from "redux-thunk";
import sessionStorage from "redux-persist/es/storage/session";
import checkPageReducer from "component/Header/slice";
import departmentsReducer from "component/AddPage/slice";
import { persistReducer, persistStore } from "redux-persist";

const rootReducer = combineReducers({
  checkPage: checkPageReducer,
  departmentState: departmentsReducer,
});

const persistConfig = {
  key: "root",
  storage: sessionStorage,
  whitelist: ["departmentState"],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const sagaMiddleware = createSagaMiddleware();

export const store = configureStore({
  reducer: persistedReducer,
  middleware: [thunk, sagaMiddleware],
});

export const persistor = persistStore(store);

sagaMiddleware.run(rootSaga);

export type AppDispatch = typeof store.dispatch;
export default store;

export type RootState = ReturnType<typeof store.getState>;
